import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import DynamicForm from '../../../../customformComponent/customForm/DynamicForm';
import backicon from "../../../../../Assets/icons/backIcon.svg"
import './AddCustomer.scss'
import axiosInstance from '../../../../services/api/API';
import AddIssueDynemicForm from '../../../Services/addIssueDynemicFrom';
import { Modal, Offcanvas } from "react-bootstrap";
import moment from "moment";
import { showCustomAlert } from '../../../../customComponents/CustomSweetAlert';
import { showErrorAlert } from '../../../../customComponents/CustomSweetAlert/errorsweetalert';
import SalesDynamicForm from '../../SalesComponents/SalesDynamicform';
import Swal from 'sweetalert2';
import { min18YearsAgo } from '../../../../../constants/DOBCommon';


const AddCustomer = () => {

  const navigate = useNavigate()

  const [formData, setFormData] = useState({});
  const [openCustomerModel, setOpenCustomerModel] = useState(false);
  const [validationErrors,setValidationErrors] = useState({})
  const [leadSourceOptions, setLeadSourceOptions] = useState([]);
  const [titleoptions,settitleOptions] = useState([])

  const [showParentDesignation, setShowParentDesignation] = useState(false);
  const [occupationDD, setOccupationDD] = useState([]);

  const [ source , setSource] = useState([])

  const [ priority, setPriority ] = useState([])

  const [languageDD, setLanguageDD] = useState([]);
  const [activeButton, setActiveButton] = useState("customer");
  const [showVehicleForm, setShowVehicleForm] = useState(false);

  const [titleDD, setTitleDD] = useState([]);

  const [loading, setLoading] = useState(false);

  const [product, setProduct] = useState([]);
  const [variantDD, setVariantDD] = useState([]);

  const token = localStorage.getItem("authToken");

  const [ customerddl, setCustomerDDl ]  = useState([])
  const [ customerIdVal, setCustomerIdVal ] = useState([])
  const [ leadCodeOPtions, setLeadCodeOptions ] = useState([])

  const [ visitTypeDdl , setVisitTypeDdl ] = useState([])

  const [ custVisitTypeId, setCustVisitTypeId ] = useState([])

  const [pincode, setPincode] = useState("");
  const [pincodeData,setPincodeData]= useState([])


// Fetch pincode, city, state, and country based on pincode
useEffect(() => {
  if (pincode?.length === 6 || formData?.pincode?.length === 6) {
    const fetchPincodeData = async () => {
      try {
        const response = await axiosInstance.post(
          "/pincodestatecity/getbypincode",
          { pincode: pincode },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          const data = response?.data?.data[0];

          if (!data) {
            setPincodeData(data);
            // You can handle the "Invalid Pincode" message here
          } else {
            setPincodeData(data);
            // Update formData with city, state, and country details
            setFormData((prevData) => ({
              ...prevData,
              city: data?.city_name,
              city_id: data?.city_id,
              state: data?.state_name,
              state_id: data?.state_id,
              country: data?.country_name,
              country_id: data?.country_id,
            }));
          }
        } else {
          throw new Error("Failed to fetch data");
        }
      } catch (error) {
        console.error("Error fetching pincode data:", error);
      }
    };

    fetchPincodeData();
  }
}, [pincode, formData?.pincode]);

// Set the pincode when formData's pincode changes
useEffect(() => {
  if (formData?.pincode?.length === 6) {
    setPincode(formData?.pincode);
  }
}, [formData?.pincode]);

// Fetch customer details based on the selected lead customer ID
useEffect(() => {
  const custId = formData.lead_customer_id;
  if (custId) {
    fetchCustomerList(custId);
  }
}, [formData.lead_customer_id]);

// Fetch customer list and update formData with customer and address details
const fetchCustomerList = async (custId) => {
  try {
    const business_partner_id = 1;
    const response = await axiosInstance.post(
      "/salesvisit/ddlcustomerlist",
      {
        business_partner_id,
        customer_id: custId,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const fetchedData = response.data.data.data[0];
    const formatedData = {
      lead_customer_id: custId,
      mobile_no: fetchedData.mobile_no,
      address: fetchedData.address,
      pincode: fetchedData.pincode,  // Include the pincode here
      city_id: fetchedData.city_id,
      state_id: fetchedData.state_id,
      country_id: fetchedData.country_id,
    };

    // Update the formData with fetched customer details
    setFormData((prevData) => ({
      ...prevData,
      ...formatedData,
    }));

    // Set the pincode directly to trigger the pincode API call
    setPincode(fetchedData.pincode);

  } catch (error) {
    console.error("Error fetching customer data:", error);
  }
};




  useEffect(() => {
    fetchCustomerDdList()
  },[])
  
  const fetchCustomerDdList = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/salesvisit/ddlcustomerlist",
        {
          business_partner_id,
          customer_id:""
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.lead_customer_id,
      }));

      setCustomerDDl(options);

      const customerId = options.lead_customer_id
      console.log(customerId, "custId")
      // console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  useEffect(() => {
    console.log(formData, "FORMDATACUSTID")
  })

    useEffect(() => {
    const custId = formData.lead_customer_id;
    console.log(custId, "CustId")
    if(custId){
      fetchCustomerLeadCodeList(custId);
      setLeadCodeOptions([])
    }
  }, [formData.lead_customer_id]);

  const fetchCustomerLeadCodeList = async (custId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/salesvisit/getleadcodebycustomerid",
        {
          business_partner_id,
          customer_id: custId
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.Details.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setLeadCodeOptions(options)

      // setCustomerDDl(options);
      console.log(options, "leadOPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  }


  useEffect(() => {
    fetchVisitTypeDdList()
  }, [])

  const fetchVisitTypeDdList = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/salesvisit/ddlvisittype",
        {
          business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setVisitTypeDdl(options);

      const customerId = options.customer_id
      console.log(customerId, "custId")
      // console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };


  useEffect(() =>{
    fetchCustVisitTypeDdList()
  },[])

  const fetchCustVisitTypeDdList = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/salesvisit/ddlcustomervisittype",
        {
          business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setCustVisitTypeId(options);

      const customerId = options.customer_id
      console.log(customerId, "custId")
      // console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };


  useEffect(() => {
    fetchLanguageOptions();
  }, []);

  const fetchLanguageOptions = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/language/ddllanguage",
        {
          business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setLanguageDD(options);
      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };


  useEffect(() => {
    fetchProductOptions();
  }, []);

  const fetchProductOptions = async () => {
    try {
      const response = await axiosInstance.post(
        "/product/ddlproduct",
        {
          business_partner_id: 1
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const options = response.data.data.data.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));

      setProduct(options);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };


  useEffect(() => {

    const productId = formData.product_id;

    if (productId ) {
      fetchVariantDD(productId);
      setVariantDD([]);
    }

    // fetchVariantDD()
  },[formData.product_id,])

  const fetchVariantDD = async (productId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        {
          business_partner_id,
          product_id: productId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fetchedData = response.data.data.data;
      const variantdata = fetchedData.map((dropdown) => ({
        value: dropdown.ID,
        label: dropdown.NAME,
      }));
      setVariantDD(variantdata);
    } catch (error) {
      console.log(error, "error");
    }
  };


  const CustomerInputs = [  
    {
      name: "lead_customer_id",
      label: "Customer Name",
      type: "dropdown",
      placeholder:"Enter Customer Name",
      options:customerddl,
      required: true,
      iscustomer:true,
      gridClass: "col-lg-4",
    },
    {
      name: "customer_visit_type_id",
      label: "Customer Visit Type",
      type: "dropdown",
      options: custVisitTypeId,
      // placeholder:"Enter Lead No.",
      // isVisible:false,
      required: true,
      gridClass: "col-lg-4",
      validation:{required:true},
    },
    // {
    //   name: "visit_type_id",
    //   label: "Lead Type",
    //   type: "dropdown",
    //   options:visitTypeDdl ,
    //   // placeholder:"Enter No.",
    //   required: true,
    //   gridClass: "col-lg-4",
    // },
    {
      name: "lead_id",
      label: "Lead No.",
      type: "dropdown",
      placeholder:"Enter Customer Type",
      options:leadCodeOPtions,
      required: true,
      gridClass: "col-lg-4",
      required: true,
      isVisible: false,
      validation:{required:true},
    },
    // {
    //   name: "transaction_no",
    //   label: "Transaction No.",
    //   placeholder:"Enter Transaction No.",
    //   type: "text",
    //   required: false,
    //   gridClass: "col-lg-4",
    //   disabled:true
    // },
    {
      name: "visit_date",
      label: "Visit Date",
      placeholder:"Enter Visit Date",
      type: "date",
      required: true,
      gridClass: "col-lg-4",
      validation:{required:true},
      // disabled:true
    },
    {
      name: "mobile_no",
      label: "Contact No.",
      type: "text",
      placeholder:"Enter Contact No.",
      // options:titleoptions,
      required: true,
      gridClass: "col-lg-4",
      // validation: { 
      //   required: true, pattern: /^[6-9]/ ,
      //   minLength:10,
      //   maxLength:10,
      //   message1: "Contact no should start with 6, 7, 8, 9",
      //   message: "Please enter a valid 10-digit",
      // },
      disabled:true
    },
    { 
      name: "address",
      label: "Address",
      type: "text",
      placeholder:"Enter Address",
      // options:leadSourceOptions,  
          required: true,
      gridClass: "col-lg-4",
      disabled:true
    },
  
    {
      name: "pincode",
      label: "Pincode",
      type: "text",
      required: true,
      placeholder:"Enter Pincode",
      gridClass: "col-lg-4",
      disabled:true
    },
   
    {
      name: "city",
      label: "City",
      type: "text",
      placeholder:"Enter City Name",
      required: true,
      gridClass: "col-lg-4",
      disabled:true
    },
    {
      name: "state",
      label: "State",
      type: "text",
      placeholder:"Enter State",
      required: true,
      gridClass: "col-lg-4",
      disabled:true
    },
    {
      name: "country",
      label: "Country",
      type: "text",
      placeholder:"Enter Country",
      required: true,
      gridClass: "col-lg-4",
      disabled:true
    },
    // {
    //   name: "address",
    //   label: "Address",
    //   type: "text",
    //   placeholder:"Enter Address",
    //   required: true,
    //   gridClass: "col-lg-4",
    // },
    // {
    //     name: "fuel_type",
    //     label: "Fuel Type",
    //     type: "multiselectdropdown",
    //     required: true,
    //     options: [
    //       { label: "DIESEL", value: "DIESEL" },
    //       { label: "PETROL", value: "PETROL" },
    //     ],
    //     gridClass: "col-lg-4",
    //   },
    // {
    //   name: "color",
    //   label: "Color",
    //   type: "text",
    //   required: true,
    //   gridClass: "col-lg-4",
    // },
    // {
    //   name: "price",
    //   label: "Price",
    //   type: "number",
    //   required: true,
    //   gridClass: "col-lg-4",
    // },,
  ];
  

  // useEffect(() => {
  //   fetchCustomerIdData();
  // }, [])

  const handleVehicleClick = () => {
    setActiveButton("vehicle");
    setShowVehicleForm(true); // Show the Vehicle form
    // fetchCustomerIdData();
    setFormData({Trans_Date: new Date(),
      Allocation_Date: new Date(),})
  };


  const handleClose = () => {
    setOpenCustomerModel(false);
    setFormData({})
  };
  const onclickOpenFrom = () => {
    setOpenCustomerModel(true);
  };


  const handleFormSubmit = async (formData) => {
    console.log("clicked")
    const errors = {};
    let isValid = true;
  
    // Validation logic
    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      } else if (
        field.required &&
        field.validation &&
        field.validation.pattern &&
        !field.validation.pattern.test(formData[field.name])
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });
  
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to add this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
    try{

      const formattedDOB = moment(formData.dob).format("YYYY-MM-DD");
      const resposne = await axiosInstance.post(
        "/salesvisit/createvisit",
        {
          business_partner_id: 1,
          customer_id:formData.lead_customer_id,
          lead_id:formData.lead_id,
          transaction_code:"",
          visit_type_id:formData.visit_type_id,
          visit_date:formData.visit_date,
          customer_visit_type_id:formData.customer_visit_type_id
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // if( resposne.status === 200 ){
      //   setFormData({})
      //   navigate("/manage-sales/customer")
      // }


      if (resposne.status === 200) {
        Swal.fire({
          title: "Success",
          text: "Customer added successfully!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate('/manage-sales/customer'); 
        });
      }

    }catch(error){
      console.log(error)

      const errorMessage = error.response?.data?.message

    showErrorAlert({
      title: "Something went wrong",
      text: errorMessage || "An error occurred while processing your request.",
      callback: () => { 
        // Optional: code to execute after confirming the alert
        console.log("Error alert confirmed");
      }
    });
    }
  },
});
if (!result.isConfirmed) {
  setLoading(false); 
}
  };

  useEffect(() => {
    fetchTitleOptions();
  }, []);

  const fetchTitleOptions = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/title/ddltitle",
        {
          business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setTitleDD(options);
      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  useEffect(() => {
    fetchOccupationOptions();
  }, []);

  const fetchOccupationOptions = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/occupation/ddloccupation",
        {
          business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setOccupationDD(options);
      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  // setPriority

  useEffect(() => {
    fetchLeadSource()
  },[])


  const fetchLeadSource = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/source/ddlsource",
        {
          business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setSource(options);
      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  useEffect(() => {
    fetchLeadPriority()
  },[])


  const fetchLeadPriority = async () => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/source/ddlsource",
        {
          business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setPriority(options);
      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };


  const CustomerFromInput = [
    {
      name: "title_id",
      label: "Title",
      type: "dropdown",
      required: true,
      validation:{required:true},
      options: titleDD,
      gridClass: "col-lg-12",
    },
    {
      name: "first_name",
      label: "First Name",
      type: "text",
      required: true,
      placeholder: "Enter First Name",
      gridClass: "col-lg-12",
      validation: { required: true,
        pattern: /^[A-Za-z\s]*$/,
        message: "Only alphabets are allowed*",
        maxLength:25,
       },
      // disabled: true,
    },
    {
      name: "last_name",
      label: "Last Name",
      type: "text",
      placeholder: "Enter Last Name",
      // required: true,
      gridClass: "col-lg-12",
      validation: { required: true ,
        pattern: /^[A-Za-z\s]*$/,
        message: "Only alphabets are allowed*",
        maxLength:25,
      },
      // disabled: true,
    },
    {
      name: "mobile_no",
      label: "Mobile No.",
      type: "text",
      required: true,
      placeholder: "Enter Mobile No.",
      gridClass: "col-lg-12",
      validation: { required: true,
        pattern: /^[6-9]\d{9}$/,
        message: "Please Enter Valid Mobile Number*",
        maxLength:10,
        message1: "Contact no should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit",
      }
      // disabled: true,
    },
    {
      name: "dob",
      label: "DOB",
      type: "date",
      maxDate: min18YearsAgo,
      required: true,
      gridClass: "col-lg-12",
      validation: { required: true, message: "DOB is required" },
    },
    {
      name: "email_id",
      label: "Email Id",
      type: "text",
      required: true,
      placeholder: "Enter Email Id",
      gridClass: "col-lg-12",
      validation: { required: true,
        pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
        message: "Please Enter Valid Email Id*",
        maxLength:25,
       },
      // disabled: true,
    },
    {
      name: "address",
      label: "Address",
      type: "text",
      required: true,
      placeholder: "Enter Address",
      gridClass: "col-lg-12",
      validation: { required: true },
      // disabled: true,
    },
    {
      name: "occupation_id",
      label: "Occupation",
      type: "dropdown",
      required: true,
      options: occupationDD,
      gridClass: "col-lg-12",
      validation: { required: true },
    },
    {
      name: "language_id",
      label: "Language",
      type: "dropdown",
      required: true,
      options: languageDD,
      gridClass: "col-lg-12",
      validation: { required: true },
    },
    {
      name: "pincode",
      label: "Pin Code",
      placeholder: "Enter Pin Code",
      type: "text",
      required: true,
      gridClass: "col-lg-12",
      validation: { required: true,
         maxLength: 6 
        },
    },
    {
      name: "city",
      label: "City",
      type: "text",
      placeholder: "City",
      gridClass: "col-lg-12",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "state",
      label: "State",
      type: "text",
      placeholder: "State",
      required: true,
      gridClass: "col-lg-12",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "country",
      label: "Country",
      type: "text",
      placeholder: "Country",
      required: true,
      gridClass: "col-lg-12",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "pan_no",
      label: "PAN No.",
      type: "text",
      placeholder: "Enter PAN No.",
      validation: {
        required: false,
        pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        message: "Please enter a valid 10-character PAN number",
      },
      required: false,
      gridClass: "col-lg-12",
    },
    {
      name: "source_id",
      label: "Lead Source",
      type: "dropdown",
      required: true,
      options: source,
      gridClass: "col-lg-12",
      validation: { required: true },
    },
    {
      name: "priority_id",
      label: "Lead Priority",
      type: "dropdown",
      required: true,
      options: priority,
      gridClass: "col-lg-12",
      validation: { required: true },
    },
    {
      name: "product_id",
      label: "Product",
      type: "dropdown",
      required: true,
      options: product,
      gridClass: "col-lg-12",
      validation: { required: true },
    },
    {
      name: "variant_id",
      label: "Variant",
      type: "dropdown",
      required: true,
      options: variantDD,
      gridClass: "col-lg-12",
      validation: { required: true },
    },
  ];

  const handleDrawerFormCustomer = async (formData) => {
    console.log("clicked")
    const errors = {};
    let isValid = true;
    CustomerFromInput.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      } else if (
        field.required &&
        field.validation &&
        field.validation.pattern &&
        !field.validation.pattern.test(formData[field.name])
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    try {
      //const formattedDOB=format(formData.dob,"yyy-MM-dd")
      const formattedDOB = moment(formData.dob).format("YYYY-MM-DD");
      const resposne = await axiosInstance.post(
        "/salesvisit/createcustomer",
        {
          business_partner_id: 1,
          title_id: formData.title_id,
          customer_type_id: 1,
          first_name: formData.first_name,
          last_name: formData.last_name,
          email_id: formData.email_id,
          mobile_no: formData.mobile_no,
          dob: formattedDOB,
          address: formData.address,
          occupation_id: formData.occupation_id,
          language_id: formData.language_id,
          pincode: formData.pincode,
          city_id: formData.city_id,
          country_id: formData.country_id,
          state_id: formData.state_id,
          pan_no: formData.pan_no,
          status: 1,
          source_id:formData.source_id,
          priority_id:formData.priority_id,
          product_id:formData.product_id,
          variant_id:formData.variant_id

        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // if(resposne?sta)

      // console.log("API Response:", resposne.data);
      // const customerId = resposne?.data?.data?.responseData.customer_id;
      // setCustomerIdValue(customerId);

      if (resposne?.data?.status === 200) {
        console.log('231232112')
        handleVehicleClick();
        setFormData({})
        fetchCustomerDdList()
        handleClose()
    
      }
    } catch (error) {
      console.log(error, "ERROR");
    }
    
  };

  return (
    <div style={{paddingLeft:10}}>
      <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
            <div className="customer-back-buttton mt-2 mb-2">
        <img src={backicon} alt="back" onClick={()=>navigate(-1)} />
        <span className="backbtntitle">Add New Customer Visit</span>
      </div>
      <div className="btncontainer mt-3 gap-2">
      {/* <button className='customer-upload-btn'>
            Upload
        </button> */}
       
        <button
        onClick={() => handleFormSubmit(formData)}
          className="submit-btn"
        >
          Submit
        </button>
      </div>

      </div>
      <div className="form-container">
        <p style={{fontSize:"20px", color:"grey"}}>Personal Details </p>
        <SalesDynamicForm

        // formConfig={CustomerInputs}
        formConfig={CustomerInputs.map(input => {
          if (input.name === "lead_id") {
            return {
              ...input,
              isVisible: formData.visit_type_id !== 1 // Hide "Lead No." only if "New" (ID: 1) is selected
            };
          }
          if (input.name === "visit_type_id") {
            return {
              ...input,
              options: visitTypeDdl // Options received from API response
            };
          }
          return input;
        })}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}
        validationErrors={validationErrors}
        setValidationErrors={setValidationErrors}
        onclickOpenFrom={onclickOpenFrom}
        />
        <div>
        <Offcanvas
          placement={"end"}
          show={openCustomerModel}
          onHide={handleClose}
          style={{ width: "580px" }}
        >
          <Offcanvas.Header style={{ padding: "35px 70px 10px 70px" }}>
            <Offcanvas.Title>
              <div
                className="backbutton"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <img
                  src={backicon}
                  alt="back"
                  style={{ paddingBottom: "12px" }}
                  onClick={handleClose}
                />
                <p
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    paddingLeft: "5px",
                  }}
                >
                  Add New Customer
                </p>
              </div>
              <div
                className="col-12"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  paddingTop: "14px",
                }}
              >

              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body style={{ padding: "0px 72px" }}>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  // marginLeft: "80px",
                }}
              >
                <SalesDynamicForm
                  formConfig={CustomerFromInput}
                  formData={formData}
                  setFormData={setFormData}
                  onSubmit={handleDrawerFormCustomer}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors}
                  showParentDesignation={showParentDesignation}
                  setShowParentDesignation={setShowParentDesignation}
                />

                <div
                  style={{ paddingTop: "10px", paddingLeft: "90px", marginLeft:"66px" }}
                  className="col-12"
                >
                  <button
                    onClick={() => handleDrawerFormCustomer(formData)}
                    className="submit-btn w-50 p-3 "
                  >
                    {"Save and Continue"}
                  </button>
                </div>
              </div>

          </Offcanvas.Body>
        </Offcanvas>
        </div>

      </div>
    </div>
  )
}

export default AddCustomer